/***************************************************
Alexander Self
7/29/17
Root reducer: Combines all reducers
****************************************************/
import { combineReducers } from 'redux';
import authReducer from './auth_reducer';
import TimesheetReducer from './timesheet_reducer';
import MiscReducer from './misc_reducer';
import ProfileReducer from './profile_reducer';
import DashboardReducer from './dashboard_reducer';
import GangReducer from './gang_reducer';
import EquipmentReducer from './equipment_reducer';
import HarvestReducer from './harvest_reducer';
/* SMS Alerts */
import formReducer from './alerts/form_reducer';
import listReducer from './alerts/list_reducer';
import toastReducer from './alerts/toast_reducer';
import messagesReducer from './alerts/messages_reducer';
/* Cultivation */
import cultivationReducer from '../cultivation/reducers';
/* Weather */
import WeatherReducer from '../weather/reducer';
/* Irrigation */
import IrrigationReducer from '../irrigation/reducer';
/* Intervals */
import IntervalReducer from "../interval/interval_reducer";

const rootReducer = combineReducers({
  intervals: IntervalReducer,
  irrigation: IrrigationReducer,
  weather: WeatherReducer,
  cultivation: cultivationReducer,
  auth: authReducer,
  dashboard: DashboardReducer,
  timesheet: TimesheetReducer,
  misc: MiscReducer,
  profile: ProfileReducer,
  gang: GangReducer,
  equipment: EquipmentReducer,
  harvest: HarvestReducer,
  form: formReducer,
  list: listReducer,
  toast: toastReducer,
  messages: messagesReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js